module.exports = __webpack_public_path__ + "static/media/content-check.a09bd5c9.png";